module.exports = __webpack_public_path__ + "img/climate_actions_solar_energy@2x.f49ac1c.webp";